<!-- This component is used to enforce the title attribute being added to any text
     that is using Carbon truncation design principles.

     For multi-line truncation, the SCSS mixin "line-clamp" should be used alongside with this
-->
<template>
  <span
    class="ellipsis-text bx--text-truncate--end"
    v-bind="$attrs"
    :title="hideTitle ? undefined : titleText"
  >
    {{ text }}
  </span>
</template>

<script setup lang="ts">
import { isEmpty } from "@utils/var.check";
import { computed } from "vue";

// Props
interface Props {
  text?: string;
  title?: string;
  hideTitle?: boolean;
}

const { text = "", title = "", hideTitle = false } = defineProps<Props>();

// Computed
const titleText = computed(() => {
  return !isEmpty(title) ? title : text;
});
</script>
